import React from 'react';
import styles from './index.module.css';

const Panel = React.forwardRef(({width, children, className, onClick}, ref) => (
  <div ref={ref} onClick={onClick ? onClick : undefined} className={className ? styles.container+" "+className : styles.container} style={width ? {width} : null}>
    {children}
  </div>
))
export default Panel;
